module.exports = __webpack_public_path__ + "assets/medium.9327e0ac.svg";